import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";

Vue.use(Router);

const router = new Router({
  routes: [
    {
        path: "/",
        redirect: "/login"
    },
    {
        path: "/audit",
        meta: {
            title: "导入日报审核"
        },
        component: () => import("@/views/audit/audit")
    },
    {
        path: "/login",
        component: () => import("@/views/login/index"),
        meta: {
            title: "登陆"
        }
    },
    {
        path: "/register",
        component: () => import("@/views/register/index"),
        meta: {
            title: "注册"
        }
    },
    {
        path: "/expire",
        component: () => import("@/views/expire/index"),
        meta: {
            title: "到期"
        }
    },
    {
        path: "/index",
        component: () => import("@/views/index/index"),
        meta: {
            title: "CTMS临床管家",
            keepAlive: true
        }
    },
    {
        path: "/view",
        meta: {
            title: "查看日报"
        },
        component: () => import("@/views/view/index")
    },
    {
        path: "/calendar",
        meta: {
            title: "查看日报"
        },
        component: () => import("@/views/view/calendar")
    },
    {
        path: "/edit",
        meta: {
            title: "填写日报"
        },
        component: () => import("@/views/edit/index")
    },
    // 按周填报（暂时下线）
    // {
    //     path: "/weekedit",
    //     meta: {
    //         title: "按周填报"
    //     },
    //     component: () => import("@/views/edit/weekEdit")
    // },
    {
        path: "/task",
        meta: {
            title: "待办任务"
        },
        component: () => import("@/views/task/index")
    },
    {
        path: "/reviewFiles",
        meta: {
            title: "待办任务"
        },
        component: () => import("@/views/task/reviewFiles")
    },
    
    {
        path: "/expense",
        meta: {
            title: "费用报销"
        },
        component: () => import("@/views/expense/index")
    },
    {
        path: "/expenseDetails",
        name: "expenseDetails",
        meta: {
            title: "单据编辑"
        },
        component: () => import("@/views/expense/details")
    },
    {
        path: "/customizedDetail",
        name: "customizedDetail",
        meta: {
            title: "单据编辑"
        },
        component: () => import("@/views/expense/customizedDetail")
    },
    {
        path: "/projectInside",
        name: "projectInside",
        meta: {
            title: "项目详情"
        },
        component: () => import("@/views/project/projectInside")
    },
    {
        path: "/project/visit/centers",
        name: "visitCenters",
        meta: {
            title: "中心管理"
        },
        component: () => import("@/views/project/visit/centers")
    },
    {
        path: "/project/visit/followups",
        name: "visitFollowups",
        meta: {
            title: "受试者管理"
        },
        component: () => import("@/views/project/visit/followups")
    },
    {
        path: "/project/visit/process",
        name: "visitProcess",
        meta: {
            title: "随访流程"
        },
        component: () => import("@/views/project/visit/process")
    },
    {
        path: "/project/visit/starthe",
        name: "visitStarthe",
        meta: {
            title: "启动管理"
        },
        component: () => import("@/views/project/visit/starthe")
    },
    {
        path: "/project/visit/subjectDetail",
        name: "visitSubjectDetail",
        meta: {
            title: "受试人详情"
        },
        component: () => import("@/views/project/visit/subjectDetail")
    },
    {
        path: "/project/visit/attention",
        name: "visitAttention",
        meta: {
            title: "访视填报"
        },
        component: () => import("@/views/project/visit/attention")
    },
    {
        path: "/project/visit/note",
        name: "visitNote",
        meta: {
            title: "注意事项"
        },
        component: () => import("@/views/project/visit/note")
    },
    {
        path: "/project/visit/notepad",
        name: "visitNotepad",
        meta: {
            title: "随访流程/记事本"
        },
        component: () => import("@/views/project/visit/notepad")
    },
    {
        path: "/project/visit/pdf",
        name: "visitPdf",
        meta: {
            title: "PDF"
        },
        component: () => import("@/views/project/visit/pdf")
    },
    {
        path: "/notepad",
        redirect: to => ({ path: "/project/visit/notepad", query: to.query })
    },
    {
        path: "/centers",
        redirect: to => ({ path: "/project/visit/centers", query: to.query })
    },
    {
        path: "/followups",
        redirect: to => ({ path: "/project/visit/followups", query: to.query })
    },
    {
        path: "/details",
        redirect: to => ({ path: "/project/visit/subjectDetail", query: to.query })
    },
    {
        path: "/attention",
        redirect: to => ({ path: "/project/visit/attention", query: to.query })
    },
    {
        path: "/note",
        redirect: to => ({ path: "/project/visit/note", query: to.query })
    },
    {
        path: "/process",
        redirect: to => ({ path: "/project/visit/process", query: to.query })
    },
    {
        path: "/starthe",
        redirect: to => ({ path: "/project/visit/starthe", query: to.query })
    },
    {
        path: "/nearfuture",
        redirect: to => ({ path: "/visit/nearfuture", query: to.query })
    },
    {
        path: "/editProject",
        meta: {
            title: "编辑项目"
        },
        component: () => import("@/views/project/edit")
    },
    {
        path: "/editask",
        name: "editask",
        meta: {
            title: "编辑任务"
        },
        component: () => import("@/views/task/editask")
    },
    {
        path: "/search", 
        meta: {
            title: "选择项目"
        },
        component: () => import("@/views/edit/search")
    },
    {
        path: "/review",
        meta: {
            title: "审核日报"
        },
        component: () => import("@/views/review/index")
    },
    {
        path: "/profession_review",
        meta: {
            title: "专业审核"
        },
        component: () => import("@/views/review/profession_list")
    },
    {
        path: "/department_review",
        meta: {
            title: "部门审核"
        },
        component: () => import("@/views/review/department_list")
    },
    {
        path: "/msg",
        meta: {
            title: "消息记录"
        },
        component: () => import("@/views/msg/index")
    },
    {
        path: "/project",
        meta: {
            title: "项目管理"
        },
        component: () => import("@/views/project/index")
    },
    {
        path: "/error",
        meta: {
            title: "错误提示"
        },
        component: () => import("@/views/error/index")
    },
    {
        path: "/test",
        meta: {
            title: "测试页面"
        },
        component: () => import("@/views/test/index")
    },
    {
        path: "/tests",
        meta: {
            title: "测试页面2"
        },
        component: () => import("@/views/test/list")
    },
    // {
    //     path: "/timetool",
    //     meta: {
    //         title: "自动计时"
    //     },
    //     component: () => import("@/views/timetool/timetool")
    // },
    {
        path: "/exaLeave",
        meta: {
            title: "请假审批"
        },
        component: () => import("@/views/exaLeave/exaLeave")
    },
    {
        path: "/applyLeave",
        meta: {
            title: "请假申请"
        },
        component: () => import("@/views/exaLeave/applyLeave")
    },
    {
        path: "/awayOffice",
        meta: {
            title: "出差申请"
        },
        component: () => import("@/views/exaLeave/awayOffice")
    },
    {
        path: "/editPerfect",
        meta: {
            title: "完善工号"
        },
        component: () => import("@/views/editPerfect/editPerfect")
    },
    {
        path: "/clearStorage",
        meta: {
            title: "清空存储"
        },
        component: () => import("@/views/test/clearStorage")
    },
    {
        path: "/my",
        component: () => import("@/views/my/index"),
        redirect: "/my/center",
        children: [
            {
                path: "center",
                meta: {
                    title: "个人中心"
                },
                component: () => import("@/views/my/children/center")
            },
            {
                path: "set",
                meta: {
                    title: "修改密码"
                },
                component: () => import("@/views/my/children/set")
            }
        ]
    },
    {
        path: "/count",
        component: () => import("@/views/count/count"),
        meta: {
            title: "填报统计"
        }
    },
    {
        path: "/cost",
        component: () => import("@/views/cost/cost"),
        meta: {
            title: "成本"
        }
    },
    {
        path: "/useRegistration",
        component: () => import("@/views/deviceManagement/useRegistration"),
        meta: {
            title: "设备使用登记"
        }
    },
    {
        path: "/usageHistory",
        component: () => import("@/views/deviceManagement/usageHistory"),
        meta: {
            title: "设备使用记录"
        }
    },
    {
        path: "/overtime",
        component: () => import("@/views/exaLeave/overtime"),
        meta: {
            title: "加班管理"
        }
    },
    {
        path: "/pdf",
        meta: {
            title: "PDF"
        },
        component: () => import("@/views/pdf/ppd")
    },
    {
        path: "/visit/calendar",
        name: "visitCalendar",
        meta: {
            title: "随访日历"
        },
        component: () => import("@/views/visitCalendar/calendar")
    },
    {
        path: "/visit/nearfuture",
        name: "visitNearfuture",
        meta: {
            title: "近期随访"
        },
        component: () => import("@/views/visitCalendar/nearfuture")
    },
    {
        path: "/visit/audit",
        name: "visitAudit",
        meta: {
            title: "随访审核"
        },
        component: () => import("@/views/visitAudit/edits")
    },
    {
        path: "/visit/phase",
        name: "visitPhaseAudit",
        meta: {
            title: "阶段数据审核"
        },
        component: () => import("@/views/visitAudit/phase")
    },
    {
        path: "*",
        component: () => import("@/components/NotFound")
    }
  ]
});

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

router.onError(error => {
    const chunkFailed = /Loading chunk [\d]+ failed|Loading CSS chunk [\d]+ failed/;
    if (chunkFailed.test(error.message)) {
        window.location.reload();
    }
});

const AUTH_ROUTES = ["/login", "/register", "/expire"];

router.beforeEach((to, from, next) => {
    let { title, needLogin } = to.meta;
    let { isLogin } = store.state;
    document.title = title;

    if (AUTH_ROUTES.includes(to.path)) {
        document.body.classList.remove("ctms-app");
        document.body.classList.add("ctms-auth");
    } else {
        document.body.classList.remove("ctms-auth");
        document.body.classList.add("ctms-app");
    }

    if (needLogin && !isLogin) {
        next({
            path: "/login"
        });
    } else {
        next();
    }
});

export default router;
